// extracted by mini-css-extract-plugin
module.exports = {"currentImage":"MultiImage_currentImage__3h5jZ","frame":"MultiImage_frame__jUi_s","imageList":"MultiImage_imageList__1nGW8","new":"MultiImage_new__3Q0Dg"};